import Project from "../constants/project";

export function getBotUrl() {
  switch (process.env.REACT_APP_PROJECT) {
    case Project.CHATBOT:
    case Project.CHATBOT_V2:
      return "https://t.me/chatbot";
    case Project.ANONRUBOT:
      return "https://t.me/anonrubot";
    default:
      console.error("Unknown project", process.env.REACT_APP_PROJECT);
      return "https://t.me/anonrubot";
  }
}
